<template>
  <div class="copy-message-alert" :class="{'show' : isShown}">
    <img src="/main/img/icons/check.svg" /> {{trans('message_copied',{issue: this.type === 'image' ? trans('photo') : trans('message')})}}
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import chatModule from '@chat/module/store/type'

export default {
  props: ['isShown', 'type'],

  mixins: [
    require('@general/lib/mixin').default
  ],
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    ...mapActions({
    }),
  },

  watch: {
  },
  data() {
    return {
    }
  }
}
</script>
